import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Livecoding #35 - A New Site for reactd3js.com",
  "description": "",
  "published": "2017-03-13T00:00:00.000Z",
  "redirect_from": ["/blog/livecoding-35-new-site-reactd3jscom/swizec/7486"],
  "categories": "Livecoding, Technical",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`This is a Livecoding Recap – an almost-weekly post about interesting things discovered while livecoding ?. Almost always under 500 words and with pictures. You can follow my channel, `}<a parentName="em" {...{
          "href": "https://liveedu.tv/swizec"
        }}>{`here`}</a>{`. New content almost `}<strong parentName="em">{`every Sunday at 2pm Pacific`}</strong>{`. There’s live chat, come say hai ?`}</em></p>
    <p>{`<`}{`This is where a video of the livecoding would go, but LiveEdu saved only the first 5 minutes. The rest went poof ?>`}</p>
    <lite-youtube {...{
      "videoid": "BLXdkap8DEM",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`I guess I `}<em parentName="p">{`could`}</em>{` upload my own copy to Youtube and embed that… ?`}</p>
    <p>{`Anyway… today, we built this: `}<a parentName="p" {...{
        "href": "http://www.reactd3js.com"
      }}>{`reactd3js.com`}</a>{` – a new site for all things React & D3v4. After two years of working on `}<a parentName="p" {...{
        "href": "https://swizec.com/reactd3js"
      }}>{`React+D3js the book`}</a>{`, it dawned on me that “Hey, maybe I should buy the domain!”`}</p>
    <p>{`Nobody else thought to get it either :D`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`I can't believe it took me 2 years to think to buy `}<a parentName="p" {...{
          "href": "https://t.co/yR10G3DQpo"
        }}>{`https://t.co/yR10G3DQpo`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/840270745724829696"
      }}>{`March 10, 2017`}</a></blockquote>
    <p>{`The new site isn't much to look at, and it doesn't have to be. It exists, and that's what matters because now I can make stickers! Right now, the site is a link to the book and to the next workshop.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/03/Screen-Shot-2017-03-12-at-23.41.01.png",
        "alt": null
      }}></img></p>
    <p>{`Ok, I'll be honest: 90% of that screenshot happened many hours after livecoding was over. Writing with people watching over my shoulder still feels weird.`}</p>
    <p>{`So what did we learn while livecoding this?`}</p>
    <p>{`We learned that Canon didn't think their flip screen UX through. The cable between the camera and the computer covers the screen you use to see yourself. Maybe they never intended you to `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/connected-canon-dslr-webcam/swizec/7477"
      }}>{`use your DSLR as a webcam`}</a>{`? Who knows ...`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Canon did not think this through `}<a parentName="p" {...{
          "href": "https://twitter.com/hashtag/livecoding?src=hash&ref_src=twsrc%5Etfw"
        }}>{`#livecoding`}</a>{` `}<a parentName="p" {...{
          "href": "https://t.co/mI3KPrJDAX"
        }}>{`pic.twitter.com/mI3KPrJDAX`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/841035308607000576"
      }}>{`March 12, 2017`}</a></blockquote>
    <p>{`We also learned that `}<a parentName="p" {...{
        "href": "https://www.liveedu.tv/daemon92/"
      }}>{`@daemon92`}</a>{` misses Kiwi butt. With the new camera, my bird no longer puts his butt in front of the camera. Such loss.`}</p>
    <p>{`And Daemon is still doing homework. He hopes to finish soon, so he can go spring break and party. Young'uns these days… when I was in college, we partied first and studied second.`}</p>
    <p>{`We also learned that setting up a custom domain for Github pages is still confusing. Documentation feels circular, fragmented into too many pages that say two sentences, then tell you to go somewhere else for the real answer. It's ridiculous.`}</p>
    <p>{`At least they create `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/reactd3js.com/blob/master/CNAME"
      }}>{`the CNAME file`}</a>{` for you these days. I think that's how Github servers know which repository a domain links to.`}</p>
    <p>{`I mean, you're setting DNS to point at Github servers in general. They must be doing some sort of resolving internally.`}</p>
    <p>{`It's been a while since I sysadmined ?`}</p>
    <p>{`Oh, and fundamentally, we learned that using a custom domain when hosting your site on Github pages disables https. No green checkmark for your beautiful new page.`}</p>
    <p>{`This makes sense of course. They'd have to issue certificates for each domain hosted on their servers, and that kind of defats the purpose.`}</p>
    <p>{`Oh, and we learned that to get `}<a parentName="p" {...{
        "href": "https://github.com/NekR/offline-plugin"
      }}>{`Webpack offline-plugin`}</a>{` to work, you have to `}<inlineCode parentName="p">{`npm run eject`}</inlineCode>{` your app. This is unfortunate because you lose automatic `}<inlineCode parentName="p">{`react-scripts`}</inlineCode>{` updates, but worth it because it makes your site hella fast. Hella. ?`}</p>
    <p>{`Until next time, happy hacking. ?`}</p>
    <p>{`PS: I later learned that running offline-plugin on localhost is a bad idea`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Ok so, running `}<a parentName="p" {...{
          "href": "https://twitter.com/nekrtemplar"
        }}>{`@nekrtemplar`}</a>{`'s offline-plugin on localhost can have funny permanent consequences ...`}<br parentName="p"></br><br parentName="p"></br>{`TIL `}<a parentName="p" {...{
          "href": "https://t.co/KfxSwp94Wm"
        }}>{`pic.twitter.com/KfxSwp94Wm`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/841526755517116416"
      }}>{`March 14, 2017`}</a></blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      